import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VehiclesLookup'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VehiclesLookupStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VehiclesLookupStore",
			variables: false,
		})
	}
}

export async function load_VehiclesLookup(params) {
  await initClient()

	const store = new VehiclesLookupStore()

	await store.fetch(params)

	return {
		VehiclesLookup: store,
	}
}
